import {Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import {base64StringToBlob} from 'blob-util';
import {Batch} from '../../interfaces/batches/batch';
import {BatchDocumentsRepositoryService} from '../../services/batch-documents/batch-documents-repository-services';
import {eBatchType} from "../../enums";
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'lib-download-batch-documents',
    templateUrl: './download-batch-documents.component.html',
    styleUrl: './download-batch-documents.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DownloadBatchDocumentsComponent {
  private readonly transloco = inject(TranslocoService);
  @Input({ required: true }) batch!: Batch;

  constructor(private documentsRepo: BatchDocumentsRepositoryService) { }

  hasDocuments(): boolean {
    return (this.hasBatchDocument() ||
      this.hasNormalizedBatchDocument() ||
      this.hasBatchResultDocument() ||
      this.hasRegistryDocuments() ||
      this.hasRegHubDocuments());
  }

  hasBatchDocument(): boolean {
    return !!this.batch.rawDocument;
  }

  hasNormalizedBatchDocument(): boolean {
    return (!!this.batch.normalizedDocument && this.batch.normalizedDocument.id != this.batch.rawDocument?.id);
  }

  hasBatchResultDocument(): boolean {
    return !!this.batch.batchResultDocument;
  }

  hasRegistryDocuments(): boolean {
    return !!this.batch.orderResultsDocument;
  }

  hasRegHubDocuments(): boolean {
    return !!this.batch.orderSummariesDocument;
  }

  downloadDocument(documentID?: string) {
    if (documentID) {
      //Get Document
      this.documentsRepo.getDocument(documentID!)
        .subscribe(result => {
          const documentType = `application/${result?.documentTypeID ?? "pdf"}`.toLowerCase();
          const blob = base64StringToBlob(result.base64, documentType);
          const blobURL = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobURL;
          link.download = result.fileName; // set a name for the file
          link.click();
        });
    }
  }

  batchResultLabel() {
    return this.batch.batchTypeID != eBatchType.vinSight
      ? this.transloco.translate('downloadBatchDocuments.batchResults')
      : this.transloco.translate('downloadBatchDocuments.batchResultSummary');
  }

  regHubDocumentLabel() {
    return this.batch.batchTypeID != eBatchType.vinSight
      ? this.transloco.translate('downloadBatchDocuments.regHubDocuments')
      : this.transloco.translate('downloadBatchDocuments.batchResults');
  }
}
